export enum CompanyAccountTypes {
  CompanyAdmin = 'company_admin',
  CompanyHost = 'company_host',
}
